/**
 * Add functions for Facebook
 * */

(function (pmw, undefined) {

	let fbUserData
	let fbpPromise = null

	pmw.fbeventsJsUrl = () => {

		let searchParams = new URLSearchParams(window.location.search)

		if (searchParams.has("fbevents-version")) {
			return `https://connect.facebook.net/en_US/fbevents.js?v=${searchParams.get("fbevents-version")}`
		}

		return pmwDataLayer?.pixels?.facebook?.fbevents_js_url
	}

	pmw.getFacebookPixelIds = () => {

		if (Array.isArray(pmwDataLayer?.pixels?.facebook?.pixel_ids) && pmwDataLayer.pixels.facebook.pixel_ids.length) {
			return pmwDataLayer.pixels.facebook.pixel_ids
		}

		return [pmwDataLayer.pixels.facebook.pixel_id]
	}

	/**
	 * Detect a window.fbq that was defined by a foreign script before PMW ran.
	 *
	 * Meta's own bootstrap stub sets fbq.loaded = true, and once fbevents.js has
	 * loaded, fbq.callMethod is a function. A bare fbq defined by another script
	 * (e.g. a custom audit or wrapper snippet) has neither, and its presence makes
	 * Meta's standard bootstrap (if(f.fbq)return) skip injecting fbevents.js.
	 *
	 * @returns {boolean}
	 */
	pmw.isForeignFbqStub = () => {
		return typeof window.fbq !== "undefined" &&
			typeof window.fbq.callMethod !== "function" &&
			window.fbq.loaded !== true
	}

	/**
	 * Check if Meta's automatic configuration must be disabled for a pixel.
	 *
	 * Set through the pmw_facebook_auto_config PHP filter. autoConfig off opts
	 * the pixel out of Meta's AutomaticSetup feature bundle: automatic event
	 * detection, microdata scraping and enrichment, AutomaticParameters,
	 * SmartSetup and Meta's regex and AI matching extensions. It does not stop
	 * the configuration file itself, the Event Setup Tool rules or the CAPI
	 * Gateway, which fbevents.js gates on their own opt-ins.
	 *
	 * @param {string} pixelId
	 * @returns {boolean}
	 */
	pmw.isFbAutoConfigDisabled = pixelId => {

		let disabledPixelIds = pmwDataLayer?.pixels?.facebook?.auto_config_disabled_pixel_ids

		if (!Array.isArray(disabledPixelIds)) return false

		return disabledPixelIds.map(String).includes(String(pixelId))
	}

	/**
	 * Read the restricted event names of a pixel from Meta's signals config.
	 *
	 * Pixels in restricted business categories (e.g. health and wellness) carry
	 * an eventValidation entry with restrictedEventNames in their signals config
	 * (https://connect.facebook.net/signals/config/{PIXEL_ID}). fbevents.js then
	 * silently drops those events client side: fbq("track", ...) is accepted but
	 * no request to facebook.com/tr is sent, while PageView and ViewContent keep
	 * working, so the pixel looks healthy.
	 *
	 * @param {string} pixelId
	 * @returns {Array|null} The restricted event names, or null while the signals
	 *                       config for the pixel has not been processed yet.
	 */
	pmw.getFbRestrictedEventNames = pixelId => {

		try {

			if (typeof window.fbq === "undefined" || !window.fbq.instance || !window.fbq.instance.pluginConfig) return null

			let eventValidation = window.fbq.instance.pluginConfig.get(pixelId, "eventValidation")

			if (!eventValidation) return null

			return Array.isArray(eventValidation.restrictedEventNames) ? eventValidation.restrictedEventNames : []

		} catch (e) {
			return null
		}
	}

	/**
	 * Warn when Meta restricts events for a pixel because of its business category.
	 *
	 * The signals config loads asynchronously after fbq("init", ...), so this
	 * polls the config store for a few seconds and warns once per affected pixel.
	 *
	 * @param {Array}  pixelIds
	 * @param {number} attempt
	 */
	pmw.warnOnFbRestrictedEvents = (pixelIds, attempt = 0) => {

		let pendingPixelIds = pixelIds.filter(pixelId => {

			let restrictedEventNames = pmw.getFbRestrictedEventNames(pixelId)

			// The signals config for this pixel has not been processed yet. Keep polling.
			if (null === restrictedEventNames) return true

			if (restrictedEventNames.length) {
				pmw.console.warn("Facebook Pixel " + pixelId + ": Meta restricts the following events for this pixel because of its business category (e.g. health and wellness): " + restrictedEventNames.join(", ") + ". fbevents.js silently drops these events in the browser and Meta also filters them on the Conversion API, so they will not show up in Meta even though the Pixel Manager sends them. This is enforced by Meta and not caused by the Pixel Manager. Review the business category of the pixel in the Meta Events Manager (Data sources -> select the pixel -> Settings -> Manage data source categories, and Manage event blocking). More information: https://sweetcode.com/docs/pmw/troubleshooting#meta-silently-drops-addtocart-initiatecheckout-and-purchase-restricted-business-category")
			}

			return false
		})

		if (!pendingPixelIds.length || attempt >= 15) return

		setTimeout(() => pmw.warnOnFbRestrictedEvents(pendingPixelIds, attempt + 1), 1000)
	}

	pmw.loadFacebookPixel = () => {

		try {

			if (pmw.isForeignFbqStub()) {
				pmw.console.warn("Facebook Pixel: another script has already defined window.fbq before the Pixel Manager loaded it. fbevents.js will not be loaded by the standard Meta bootstrap, so the browser pixel cannot track. Remove or fix the conflicting script.")
			}

			// @formatter:off
			!function(f,b,e,v,n,t,s)
			{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
				n.callMethod.apply(n,arguments):n.queue.push(arguments)};
				if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
				n.queue=[];t=b.createElement(e);t.async=!0;
				t.src=v;s=b.getElementsByTagName(e)[0];
				s.parentNode.insertBefore(t,s)}(window, document,'script',
				pmw.fbeventsJsUrl());
			// @formatter:on

			// Add onload handler to cache user data after fbevents.js has loaded and set the _fbp cookie
			let fbScript = document.querySelector('script[src*="fbevents.js"]')
			if (fbScript) {
				fbScript.onload = () => {
					pmw.setFbUserData()
				}
				fbScript.onerror = () => {
					pmw.console.error("Facebook Pixel: fbevents.js failed to load")
				}
			}

			let data = {}

			// Add user identifiers to data if advanced matching is enabled
			if (pmw.isFbAdvancedMatchingEnabled()) {
				data = {...pmw.getUserIdentifiersForFb()}
			}

			// Initialize each Facebook Pixel and send the first PageView event.
			// All subsequent fbq("track", ...) calls automatically fan out to every initialized pixel.
			pmw.getFacebookPixelIds().forEach(pixelId => {

				// autoConfig has to be set before the pixel is initialized.
				// https://developers.facebook.com/docs/meta-pixel/advanced/#automatic-configuration
				if (pmw.isFbAutoConfigDisabled(pixelId)) {
					fbq("set", "autoConfig", false, pixelId)
				}

				fbq("init", pixelId, data)
			})

			if (pmwDataLayer?.pixels?.facebook?.mobile_bridge_app_id) {
				fbq("set", "mobileBridge", pmwDataLayer.pixels.facebook.pixel_id, pmwDataLayer?.pixels?.facebook?.mobile_bridge_app_id)
			}

			pmw.warnOnFbRestrictedEvents(pmw.getFacebookPixelIds())

			pmwDataLayer.pixels.facebook.loaded = true

		} catch (e) {
			console.error(e)
		}
	}

	// https://developers.facebook.com/docs/meta-pixel/advanced/advanced-matching
	pmw.getUserIdentifiersForFb = () => {

		let data = {}

		// external ID
		if (pmwDataLayer?.user?.id?.raw) data.external_id = pmwDataLayer.user.id.raw
		if (pmwDataLayer?.order?.user_id) data.external_id = pmwDataLayer.order.user_id

		// email
		if (pmwDataLayer?.user?.email?.facebook) data.em = pmwDataLayer.user.email.facebook
		if (pmwDataLayer?.order?.billing_email_hashed) data.em = pmwDataLayer.order.billing_email_hashed

		// first name
		if (pmwDataLayer?.user?.first_name?.facebook) data.fn = pmwDataLayer.user.first_name.facebook
		if (pmwDataLayer?.order?.billing_first_name) data.fn = pmwDataLayer.order.billing_first_name.toLowerCase()

		// last name
		if (pmwDataLayer?.user?.last_name?.facebook) data.ln = pmwDataLayer.user.last_name.facebook
		if (pmwDataLayer?.order?.billing_last_name) data.ln = pmwDataLayer.order.billing_last_name.toLowerCase()

		// phone
		if (pmwDataLayer?.user?.phone?.facebook) data.ph = pmwDataLayer.user.phone.facebook
		if (pmwDataLayer?.order?.billing_phone) data.ph = pmwDataLayer.order.billing_phone.replace("+", "")

		// city
		if (pmwDataLayer?.user?.city?.facebook) data.ct = pmwDataLayer.user.city.facebook
		if (pmwDataLayer?.order?.billing_city) data.ct = pmwDataLayer.order.billing_city.toLowerCase().replace(/ /g, "")

		// state
		if (pmwDataLayer?.user?.state?.facebook) data.st = pmwDataLayer.user.state.facebook
		if (pmwDataLayer?.order?.billing_state) data.st = pmwDataLayer.order.billing_state.toLowerCase().replace(/[a-zA-Z]{2}-/, "")

		// postcode
		if (pmwDataLayer?.user?.postcode?.facebook) data.zp = pmwDataLayer.user.postcode.facebook
		if (pmwDataLayer?.order?.billing_postcode) data.zp = pmwDataLayer.order.billing_postcode

		// country
		if (pmwDataLayer?.user?.country?.facebook) data.country = pmwDataLayer.user.country.facebook
		if (pmwDataLayer?.order?.billing_country) data.country = pmwDataLayer.order.billing_country.toLowerCase()

		return data
	}

	pmw.getFbUserData = () => {

		/**
		 * We need to cache the FB user data for InitiateCheckout
		 * where getting the user data from the browser is too slow
		 * using pmw.getCookie().
		 *
		 * And we need the object merge because the ViewContent hit happens too fast
		 * after adding a variation to the cart because the function to cache
		 * the user data is too slow.
		 *
		 * But we can get the user_data using pmw.getCookie()
		 * because we don't move away from the page and can wait for the browser
		 * to get it.
		 *
		 * Also, the merge ensures that new data will be added to fbUserData if new
		 * data is being added later, like user ID, or fbc.
		 */

		fbUserData = {...fbUserData, ...pmw.getFbUserDataFromBrowser()}

		return fbUserData
	}

	pmw.isFbAdvancedMatchingEnabled = () => {
		if (pmwDataLayer?.pixels?.facebook?.advanced_matching) {
			return true
		}

		return false
	}

	/**
	 * Wait for _fbp cookie to be available (with timeout).
	 * Used on first pageview when fbevents.js hasn't written the cookie yet.
	 * This is non-blocking - only the calling async function waits.
	 *
	 * @param {number} maxWait - Maximum wait time in ms (default 1000)
	 * @param {number} interval - Check interval in ms (default 50)
	 * @returns {Promise<string|null>}
	 */
	pmw.waitForFbp = (maxWait = 1000, interval = 50) => {

		// Check if cookie already exists - return immediately
		let existingFbp = pmw.getCookie("_fbp")
		if (pmw.isValidFbp(existingFbp)) {
			return Promise.resolve(existingFbp)
		}

		// Return cached promise if already waiting (prevents multiple pollers)
		if (fbpPromise) return fbpPromise

		fbpPromise = new Promise((resolve) => {
			let elapsed = 0

			const check = () => {
				let fbp = pmw.getCookie("_fbp")

				if (pmw.isValidFbp(fbp)) {
					pmw.console.log("Facebook Pixel: _fbp cookie found after " + elapsed + "ms")
					fbpPromise = null // Reset for future use
					resolve(fbp)
					return
				}

				elapsed += interval
				if (elapsed >= maxWait) {
					pmw.console.log("Facebook Pixel: Timeout waiting for _fbp cookie after " + maxWait + "ms")
					fbpPromise = null // Reset for future use
					resolve(null)
					return
				}

				setTimeout(check, interval)
			}

			check()
		})

		return fbpPromise
	}

	/**
	 * Set Facebook user data, waiting for _fbp cookie if not yet available.
	 * This ensures we capture the _fbp value on first pageview.
	 */
	pmw.setFbUserData = async () => {
		await pmw.waitForFbp()
		fbUserData = pmw.getFbUserDataFromBrowser()
	}

	pmw.getFbUserDataFromBrowser = () => {

		let data = {}

		let fbp = pmw.getCookie("_fbp")
		if (pmw.isValidFbp(fbp)) {
			data.fbp = fbp
		}

		let fbc = pmw.getCookie("_fbc") || pmw.retrieveData("fbclid")
		if (pmw.isValidFbc(fbc)) {
			data.fbc = fbc
		}

		if (pmw.isFbAdvancedMatchingEnabled()) {
			if (pmwDataLayer?.user?.email?.facebook) data.em = pmwDataLayer.user.email.facebook
			if (pmwDataLayer?.user?.phone?.facebook) data.ph = pmwDataLayer.user.phone.facebook
			if (pmwDataLayer?.user?.first_name?.facebook) data.fn = pmwDataLayer.user.first_name.facebook
			if (pmwDataLayer?.user?.last_name?.facebook) data.ln = pmwDataLayer.user.last_name.facebook
			if (pmwDataLayer?.user?.city?.facebook) data.ct = pmwDataLayer.user.city.facebook
			if (pmwDataLayer?.user?.state?.facebook) data.st = pmwDataLayer.user.state.facebook
			if (pmwDataLayer?.user?.postcode?.facebook) data.zp = pmwDataLayer.user.postcode.facebook
			if (pmwDataLayer?.user?.country?.facebook) data.country = pmwDataLayer.user.country.facebook
			if (pmwDataLayer?.user?.id?.raw) data.external_id = pmwDataLayer.user.id.raw
		}

		if (navigator.userAgent) data.client_user_agent = navigator.userAgent

		// Add client IP address to user data (prefer IPv6, fall back to any IP)
		// Only use validated IPs for CAPI to ensure data quality
		const clientIp = pmw.retrieveData("client_ip") || pmw.retrieveData("ipv6") || pmw.retrieveData("ip")
		if (clientIp && pmw.isValidIpAddress && pmw.isValidIpAddress(clientIp)) {
			data.client_ip_address = clientIp
		}

		return data
	}

	pmw.isFbpSet = () => {
		return !!pmw.getCookie("_fbp")
	}

	// https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/fbp-and-fbc/
	pmw.isValidFbp = fbp => {

		let re = new RegExp(/^fb\.[0-2]\.\d{13}\.\d{8,20}$/)

		return re.test(fbp)
	}

	// https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/fbp-and-fbc/
	pmw.isValidFbc = fbc => {

		let re = new RegExp(/^fb\.[0-2]\.\d{13}\.[\da-zA-Z_-]{8,}/)

		return re.test(fbc)
	}

	pmw.fbGetProductDataForCapiEvent = product => {
		return {
			content_type: "product",
			content_name: product.name,
			content_ids : [
				product.dyn_r_ids[pmwDataLayer.pixels.facebook.dynamic_remarketing.id_type],
			],
			value       : parseFloat(product.quantity * product.price),
			currency    : pmw.getProductCurrency(product),
		}
	}

	pmw.facebookContentIds = () => {
		let prodIds = []

		Object.values(pmwDataLayer.order.items).forEach(item => {

			const productId = pmwDataLayer?.shop?.variations_output && 0 !== item.variation_id ? item.variation_id : item.id
			const product   = pmw.getDataLayerProduct(productId)

			// A product deleted since the order was placed has no data left to
			// report. Skip the line rather than lose the whole conversion.
			if (!product) {
				pmw.console.warn("Facebook: skipped an order item without product data: " + productId)
				return
			}

			prodIds.push(String(product.dyn_r_ids[pmwDataLayer.pixels.facebook.dynamic_remarketing.id_type]))
		})

		return prodIds
	}

	pmw.trackCustomFacebookEvent = (eventName, customData = {}) => {
		try {
			// The same gate every other Facebook event passes through. Checking only
			// the loaded flag would let a custom event out after the visitor revoked
			// marketing consent, because the flag records that the pixel was loaded
			// once, not that it may still fire.
			if (pmw.canNotFireFbq()) return

			let eventId = pmw.getRandomEventId()

			fbq("trackCustom", eventName, customData, {
				eventID: eventId,
			})

			pmw.console.log("Facebook Pixel: Custom event sent", eventName, customData)

			let payload = {
				facebook: {
					event_name      : eventName,
					event_id        : eventId,
					user_data       : pmw.getFbUserData(),
					event_source_url: window.location.href,
				},
			}

			// if customData not empty, add it to the payload
			if (Object.keys(customData).length) {
				payload.facebook.custom_data = customData
			}

			pmw.sendEventPayloadToServer(payload)

		} catch (e) {
			console.error(e)
		}
	}

	pmw.fbGetContentIdsFromCart = () => {

		let content_ids = []

		// Read the cart entry itself: it carries its own dyn_r_ids. Going through
		// pmwDataLayer.products would only work because saveCartObjectToDataLayer
		// happens to merge the cart into it.
		for (const key in pmwDataLayer.cart) {

			const contentId = pmw.getProductIdForSpecificPixel(pmwDataLayer.cart[key], "facebook")

			if (null !== contentId) content_ids.push(contentId)
		}

		return content_ids
	}

	/**
	 * Check if Facebook Pixel is allowed to fire
	 *
	 * @returns {boolean}
	 */
	pmw.canFireFbq = () => {

		// If the Facebook Pixel is not loaded, return false
		if (!pmwDataLayer?.pixels?.facebook?.loaded) return false

		// If the user has not given consent for marketing, return false
		if (!pmw.consent.categories.get().marketing) return false

		return true
	}

	/**
	 * Check if Facebook Pixel is not allowed to fire
	 *
	 * @returns {boolean}
	 */
	pmw.canNotFireFbq = () => {
		return !pmw.canFireFbq()
	}

}(window.pmw = window.pmw || {}));
